export class AppControls {
  static website = '49210d50-f4cc-43db-9be4-ec2cb4c504a8';
  static awsAccountId = 'aa26111f-8820-45c3-8742-dabca01f1cf6';
  static email = '66e0442e-0d1e-4a48-94c4-c2f0c0376eb8';
  static azureSubscriptionId = '730e825c-4e90-4790-a737-5896f87be88d';
}
